import moment from 'moment';
import * as _ from 'underscore';

import React, { Component } from 'react';
import { connect } from 'react-redux';

import CircularProgress from 'material-ui/Progress';

import CONF from '../../../../api/config';
import MiniCalendarDay from './MiniCalendarDay';
import Session from '../../../calendar/components/Session';
import * as DesignerTOCState from '../../../../state/reducer/designerTOC/designerTOC';
import { FEATURES } from '../../../../v5/features/components/constants';

import Console from '../../../../lib/debug';

class MiniCalendar extends Component {
    state = {
        date: this.props.currentDay
    };

    getSessions = () => {
        if (this.props.tocLoading) {
            return (
                <section className="empty-state">
                    <CircularProgress size={30} />
                    <span>Loading month</span>
                </section>
            );
        }

        let theSessions = [];
        let sessions = this.props.sessions || [];
        let sessionsCount = sessions.length;
        if (sessionsCount > 0) {
            for (let i = 0; i < sessions.length; i++) {
                let sessionDay =
                    sessions[i].weekIndex + '_' + sessions[i].index;

                if (this.state.date !== sessionDay) continue;

                const previewUrl = `/fullscreen-workout/${
                    sessions[i].workout_id
                }`;

                let session = (
                    <div style={{ position: 'relative' }}>
                        <Session
                            key={sessions[i].id}
                            session={sessions[i]}
                            isPreview={true}
                            isProgram={true}
                        />
                        <a
                            className="athlete-web-preview"
                            href={previewUrl}
                            target="_blank"
                        >
                            <i className="mdi mdi-open-in-new" />
                        </a>
                    </div>
                );
                theSessions.push(session);
            }
        }

        if (theSessions.length === 0) {
            theSessions = (
                <section className="empty-state">
                    <div>
                        <i className="mdi mdi-sleep" />
                    </div>
                    <span>Scheduled Rest Day</span>
                </section>
            );
        }

        return theSessions;
    };

    onEnter = date => {
        if (!this.props.isProgram) {
            date = moment(date).format('YYYY_M_D');
        }
        this.setState({ date });
    };

    onLeave = () => {
        let date = this.props.currentDay;
        this.setState({ date });
    };

    navigate = date => {
        let _date = date;
        let dateObj = {};
        if (!this.props.isProgram) {
            _date = new Date(date);
            dateObj = {
                month: _date.getMonth() + 1,
                day: _date.getDate(),
                year: _date.getFullYear(),
                isAthlete: this.props.isAthlete
            };
        } else {
            dateObj = _date;
            dateObj.isProgram = true;
        }

        DesignerTOCState.gotoProgramDay(dateObj, this.props.programType);
    };

    render() {
        Console.render('designer.MiniCalendar');

        let selectedDate = this.state.date || this.props.currentDay;
        if (!selectedDate) return null;

        let calendarWeeks = [];
        let calendarDays = [];
        let weekCount = 1;
        let _currentDay = selectedDate.split('_');

        let current = {
            week: parseInt(_currentDay[0]),
            day: parseInt(_currentDay[1])
        };

        for (var i = 0; i <= this.props.days; i++) {
            let week = Math.floor(i / 7);
            let day = i < 7 ? i : i - week * 7;
            let weekBody = null;
            if (!(i % 7)) {
                calendarDays = [];
            }
            let sessWeek = this.props.sessionsForCalendar[week];
            let sessions = sessWeek ? sessWeek[day] : null;
            let isSelected = week === current.week && day === current.day;
            calendarDays.push(
                <MiniCalendarDay
                    sessions={sessions}
                    index={i}
                    week={week}
                    day={day}
                    isSelected={isSelected}
                    key={`mini-cal-day-${i}`}
                    onEnter={this.onEnter}
                    onSelect={this.navigate}
                />
            );
            if (Math.floor(i + 1) / 7 === weekCount) {
                weekBody = (
                    <div className="week-body" key={`week-${weekCount}`}>
                        <div className="week-title">Week {weekCount}</div>
                        <div className="weeks-wrapper">{calendarDays}</div>
                    </div>
                );
                calendarWeeks.push(weekBody);
                weekCount++;
            }
        }

        let styles = {
            height: 219,
            width: 300
        };

        let currentDayLabel = `Day ${current.week * 7 + current.day + 1}`;
        let dayLabel = currentDayLabel;

        return (
            <div className="designer-toc-wrapper">
                <div className="designer-toc">
                    <div className="designer-toc-inner">
                        <div className="layout-column">
                            <div
                                style={styles}
                                className="mini-calendar"
                                onMouseLeave={this.onLeave}
                            >
                                <div className="mini-calendar-body">
                                    {calendarWeeks}
                                </div>
                            </div>
                        </div>
                        <div className="toc-day-preview">
                            <p className="session-preview-title">
                                Session Preview
                            </p>
                            <p className="preview-date">{dayLabel}</p>
                            <ol className="calendar-items-list the-day">
                                {this.getSessions()}
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let programDaysCount = null;
    let tocSessions = [];
    if (state.calendar.infoTree.programType === 2) {
        programDaysCount = state.calendar.dayList.length;
    }
    let isPubEnabled = state.calendar.uiTree.isPubEnabled;
    let publishTime = state.calendar.uiTree.publishTime;
    let isProgram = state.calendar.infoTree.programType === 2;
    let isAthlete = state.calendar.infoTree.programType === 4;

    let sessionsForCalendar = {};
    let sessionKeys = _.keys(state.calendar.sessionTree);
    for (var i = 0; i < sessionKeys.length; i++) {
        let key = sessionKeys[i];
        let session = { ...state.calendar.sessionTree[key].data };
        session.setKeys =
            state.calendar.sessionTree[session.workout_id].data.setKeys;
        session.sets = state.calendar.sessionTree[session.workout_id].data.sets;
        tocSessions.push(session);

        if (!sessionsForCalendar[session.weekIndex])
            sessionsForCalendar[session.weekIndex] = {};
        if (!sessionsForCalendar[session.weekIndex][session.index])
            sessionsForCalendar[session.weekIndex][session.index] = [];
        sessionsForCalendar[session.weekIndex][session.index].push({
            data: session,
            day: session.index,
            week: session.weekIndex
        });
    }

    const calendar = state.calendar;
    const infoTree = calendar ? calendar.infoTree : null;
    const team = infoTree ? infoTree.team : null;
    const programId = infoTree ? infoTree.programId : null;
    const teamId = team ? team.group_id : programId;

    return {
        ...ownProps,
        sessions: tocSessions,
        sessionsForCalendar: sessionsForCalendar,
        isPubEnabled,
        publishTime,
        isProgram,
        isAthlete,
        programType: state.calendar.infoTree.programType,
        programId: state.calendar.infoTree.programId,
        teamId,
        days: programDaysCount,
        tocLoading: state.calendar.uiTree.tocLoading,
        currentDay: state.calendar.infoTree.designerInfo.dayId
    };
};

export default connect(mapStateToProps)(MiniCalendar);



// WEBPACK FOOTER //
// ./src/view/designer/components/MiniCalendar/MiniCalendar.jsx